import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

export const Map = (props) => {
    return (
        <div className="border" style={{height: "80%"}}>
            <div id="google-maps" style={{width: "100%" ,height: "100%",minHeight: "150px"}}>
            <MapContainer center={[props.lat, props.lng]} zoom={13} scrollWheelZoom={false} style={{ width: "100%", height: "100%" }}>
                <TileLayer
                    attribution='&copy'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[props.lat, props.lng]}>
                    <Popup>{props.name}</Popup>
                </Marker>
            </MapContainer>
            </div>
        </div>
    )
}